import { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';

const useOpCode = (param: CodeReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [opCodeList, setOpCodeList] = useState<UserCodeListDto[] | any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.refcode.oplist, {...param}],
    () => fetcher.refcode.getOpList(param),
    {
      onSuccess: (res: UserCodeListResDto) => {
        switch (res.code) {
          case 200:
            setOpCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, opCodeList };
};

export default useOpCode;
